import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { ProfileManagementService } from '../service/store-management/profile-management/profile-management.service';
import { map, filter, take, switchMap, tap } from 'rxjs/operators';
import { Location } from "@angular/common";


@Injectable({
  providedIn: 'root'
})
export class HomePageResolver implements Resolve<any> {

  constructor(
    public profileManagementService: ProfileManagementService,
    private location: Location,
  ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return timer(0, 1000).pipe(
            map(() => this.profileManagementService.getProfileByStore()),
            filter(profile => (profile !== undefined && profile !== null) && !!profile.codiceCapoGruppo),
            take(1), 
            tap(() =>this.location.replaceState('')),
            switchMap(()=> of(true))
        );
    } 
}
